import React, { Component } from "react";
import QRCode from "qrcode.react";
import "./Report.css";
import _ from "lodash";
import intl from 'react-intl-universal';
import '../person/config'

{/** dot时间 */ }
const Tyre_dot = props => {
    const _data = props.data;
    let lang = intl.options.currentLocale
    let Ctime = props.time
    let Ctimeuser = Ctime.replace('T', ' ')
    let model = props.model;
    _data.lf.position = { left: 10, top: lang == 'zh' ? 20 : 10 };
    _data.rf.position = { right: 10, top: lang == 'zh' ? 20 : 10 };
    _data.lb.position = { left: 10, top: lang == 'zh' ? 210 : 230 };
    _data.rb.position = { right: 10, top: lang == 'zh' ? 210 : 230 };

    _data.lf.desc = { left: 0, top: lang == 'zh' ? 80 : 130 };
    _data.rf.desc = { right: 0, top: lang == 'zh' ? 80 : 130 };
    _data.lb.desc = { left: 0, top: lang == 'zh' ? -50 : -40 };
    _data.rb.desc = { right: 0, top: lang == 'zh' ? -50 : -40 };

    // 返回轮胎位置
    const returnTyrePosition = key => {
        switch (key) {
            case "lf":
                return intl.get('txt_zqlun');
            case "lb":
                return intl.get('txt_zhlun');
            case "rf":
                return intl.get('txt_yqlun');
            case "rb":
                return intl.get('txt_yhlun');
        }
    };

    const returnDottx = (data) => {
        let temp = returnTyreInfo(data, 0);
        if (temp && temp.length >= 3) {
            var tmpdata = temp.slice(2);
            let thatyear = Number(tmpdata) + 2000
            let week = temp.slice(0, 2);
            console.log('temp=' + temp + 'tmpdata=' + tmpdata + 'week=' + week)
            let str = intl.get('txt_dotscsj')
            str = str.replace(new RegExp("\\{" + 0 + "\\}", "g"), temp)
            str = str.replace(new RegExp("\\{" + 1 + "\\}", "g"), thatyear)
            str = str.replace(new RegExp("\\{" + 2 + "\\}", "g"), week)
            return str
        } else {
            return intl.get('txt_whqdscsj')
        }
    }

    //返回每个轮子的图片index与提示文字
    const returnRemindTextAndImgIndex = (data, wear, season) => {
        let temp = returnTyreInfo(data, 0);
        let waishang = returnTyreInfo(data, 3)
        let waishangcd = returnTyreInfo(data, 5)


        if (waishang.indexOf('trauma_normal') > -1 || (waishang.indexOf('trauma_normal') == -1 && waishangcd && waishangcd == 'damage_low')) {

            if (wear && wear < 25) {
                return { index: 19, text: intl.get('txt_msyzljgh') }
            }


            if (model == 'dach.tyrescan.ts004') {
                if (season && season == 'season_summer' && wear <= 30) {
                    return { index: 19, text: intl.get('txt_msyzljgh') }
                }
                if (season && (season == 'season_winter' ||season == 'season_all' ||season == 'season_other')  && wear <= 40) {
                    return { index: 19, text: intl.get('txt_msyzljgh') }
                }

            }


            if (temp && temp.length >= 3) {

                var tmpdata = temp.slice(2);

                let thatyear = Number(tmpdata) + 2000
                let thatYearOfDay = (temp.length > 3 ? Number(temp.slice(0, 2)) : Number(temp.slice(0, 1))) * 7;
                let current_year = Ctimeuser.slice(0, 4);
                let dateFormat = Ctimeuser.replace(/-/g, '/'); // 将 - 转为 /  // 将-替换成/
                let currentYearOFday = Math.ceil((Date.parse(dateFormat) - new Date(new Date().getFullYear().toString())) / (24 * 60 * 60 * 1000)) + 1
                console.log('currentYearOFday=' + currentYearOFday)
                //每个轮子的使用天数 
                let RemainingDays = (currentYearOFday - thatYearOfDay) + (current_year - thatyear) * 365;

                if (RemainingDays < 0) {
                    RemainingDays = 1820
                }
                if (RemainingDays >= 1820) {

                    return { index: 19, text: intl.get('txt_tire_age_5') }
                }
                //每个轮子的剩余使用天数
                let day = 1820 - RemainingDays

                let tm = (80 - wear) / (10 * RemainingDays)
                let day1 = (wear - 25) / (tm * 10)
                console.log('tm=' + tm + '---day=' + day + '----day1=' + day1 + 'RemainingDays' + RemainingDays)
                let chaju = RemainingDays;
                if (day1 < day && wear < 65) {
                    chaju = 1820 - day1
                    day = day1
                    day = parseInt(day)

                }

                if (day < 0) {
                    return { index: 19, text: intl.get('txt_tire_age_5') }
                }
                let index = 0
                if (chaju <= 182) {
                    index = 0
                } else if (chaju > 182 && chaju < 273) {
                    index = 1
                } else if (chaju >= 273 && chaju < 364) {
                    index = 2
                } else if (chaju >= 364 && chaju < 455) {
                    index = 3
                } else if (chaju >= 455 && chaju < 546) {
                    index = 4
                } else if (chaju >= 546 && chaju < 637) {
                    index = 5
                } else if (chaju >= 637 && chaju < 728) {
                    index = 6
                } else if (chaju >= 728 && chaju < 819) {
                    index = 7
                } else if (chaju >= 819 && chaju < 910) {
                    index = 8
                } else if (chaju >= 910 && chaju < 1001) {
                    index = 9
                } else if (chaju >= 1001 && chaju < 1092) {
                    index = 10
                } else if (chaju >= 1092 && chaju < 1183) {
                    index = 11
                } else if (chaju >= 1183 && chaju < 1274) {
                    index = 12
                } else if (chaju >= 1274 && chaju < 1365) {
                    index = 13
                } else if (chaju >= 1365 && chaju < 1456) {
                    index = 14
                } else if (chaju >= 1456 && chaju < 1547) {
                    index = 15
                } else if (chaju >= 1547 && chaju < 1638) {
                    index = 16
                } else if (chaju >= 1638 && chaju < 1729) {
                    index = 17
                } else if (chaju >= 1729 && chaju < 1820) {
                    index = 18
                } else if (chaju >= 1820) {
                    index = 19
                }
                let str = intl.get('txt_dotjstx')

                // str = str.replace(new RegExp("\\{" + 0 + "\\}", "g"), day)
                str = ''

                return {
                    index: index,
                    text: str
                }

            } else {

                return {
                    index: 0,
                    text: ''
                }
            }

        } else if (waishangcd && waishangcd == 'damage_high') {
            return {
                index: 19,
                text: intl.get('txt_serious_trauma_check')
            }
        } else {
            return {
                index: 0,
                text: ''
            }
        }

    }


    //返回每个轮子的图片index与提示文字-model玛莎拉蒂
    const returnMSRemindTextAndImgIndex = (data, wear) => {
        let temp = returnTyreInfo(data, 0);
        let waishang = returnTyreInfo(data, 3)
        let waishangcd = returnTyreInfo(data, 5)
        const year_8 = 2919;
        console.log('wear=' + wear)
        if (waishang.indexOf('trauma_normal') > -1 || (waishang.indexOf('trauma_normal') == -1 && waishangcd && waishangcd == 'damage_low')) {

            if (wear && wear < 25) {
                return { index: 19, text: intl.get('txt_msyzljgh') }
            }
            if (temp && temp.length >= 3) {

                var tmpdata = temp.slice(2);

                let thatyear = Number(tmpdata) + 2000
                let thatYearOfDay = (temp.length > 3 ? Number(temp.slice(0, 2)) : Number(temp.slice(0, 1))) * 7;
                let current_year = Ctimeuser.slice(0, 4);
                let dateFormat = Ctimeuser.replace(/-/g, '/'); // 将 - 转为 /  // 将-替换成/
                let currentYearOFday = Math.ceil((Date.parse(dateFormat) - new Date(new Date().getFullYear().toString())) / (24 * 60 * 60 * 1000)) + 1
                console.log('currentYearOFday=' + currentYearOFday)
                //每个轮子的使用天数 
                let RemainingDays = (currentYearOFday - thatYearOfDay) + (current_year - thatyear) * 365;

                if (RemainingDays < 0) {
                    RemainingDays = year_8
                }
                if (RemainingDays >= year_8) {

                    return { index: 19, text: intl.get('txt_tire_age_8') }
                }
                //每个轮子的剩余使用天数
                let day = year_8 - RemainingDays

                let tm = (80 - wear) / (10 * RemainingDays)
                let day1 = (wear - 25) / (tm * 10)
                console.log('tm=' + tm + '---day=' + day + '----day1=' + day1 + 'RemainingDays' + RemainingDays)
                let chaju = RemainingDays;
                if (day1 < day && wear < 65) {
                    chaju = year_8 - day1
                    day = day1
                    day = parseInt(day)

                }

                if (day < 0) {
                    return { index: 19, text: intl.get('txt_tire_age_8') }
                }
                let index = 0
                console.log('chaju=' + chaju);
                if (chaju <= 182) {
                    index = 0
                } else if (chaju > 182 && chaju < 364) {
                    index = 1
                } else if (chaju >= 364 && chaju < 546) {
                    index = 2
                } else if (chaju >= 546 && chaju < 729) {
                    index = 3
                } else if (chaju >= 729 && chaju < 875) {
                    index = 4
                } else if (chaju >= 875 && chaju < 1021) {
                    index = 5
                } else if (chaju >= 1021 && chaju < 1167) {
                    index = 6
                } else if (chaju >= 1167 && chaju < 1313) {
                    index = 7
                } else if (chaju >= 1313 && chaju < 1459) {
                    index = 8
                } else if (chaju >= 1459 && chaju < 1605) {
                    index = 9
                } else if (chaju >= 1605 && chaju < 1751) {
                    index = 10
                } else if (chaju >= 1751 && chaju < 1897) {
                    index = 11
                } else if (chaju >= 1897 && chaju < 2043) {
                    index = 12
                } else if (chaju >= 2043 && chaju < 2189) {
                    index = 13
                } else if (chaju >= 2189 && chaju < 2335) {
                    index = 14
                } else if (chaju >= 2335 && chaju < 2481) {
                    index = 15
                } else if (chaju >= 2481 && chaju < 2627) {
                    index = 16
                } else if (chaju >= 2627 && chaju < 2773) {
                    index = 17
                } else if (chaju >= 2773 && chaju < year_8) {
                    index = 18
                } else if (chaju >= year_8) {
                    index = 19
                }
                let str = intl.get('txt_dotjstx')

                // str = str.replace(new RegExp("\\{" + 0 + "\\}", "g"), day)
                str=''

                return {
                    index: index,
                    text: str
                }

            } else {

                return {
                    index: 0,
                    text: ''
                }
            }

        } else if (waishangcd && waishangcd == 'damage_high') {
            return {
                index: 19,
                text: intl.get('txt_serious_trauma_check')
            }
        } else {
            return {
                index: 0,
                text: ''
            }
        }

    }


    // 返回 信息
    const returnTyreInfo = (data, index) => {
        if (data) {
            return data.split(/,|，/)[index] ? data.split(/,|，/)[index] : "-";
        }
        return "-";
    };

    const Limages = intl.options.currentLocale == 'it' ? [

        require(`../../assets/report/LDotititem_2_1.png`),
        require(`../../assets/report/LDotititem_2_2.png`),
        require(`../../assets/report/LDotititem_2_3.png`),
        require(`../../assets/report/LDotititem_2_4.png`),
        require(`../../assets/report/LDotititem_2_5.png`),
        require(`../../assets/report/LDotititem_2_6.png`),
        require(`../../assets/report/LDotititem_2_7.png`),
        require(`../../assets/report/LDotititem_2_8.png`),
        require(`../../assets/report/LDotititem_2_9.png`),
        require(`../../assets/report/LDotititem_2_10.png`),
        require(`../../assets/report/LDotititem_2_11.png`),
        require(`../../assets/report/LDotititem_2_12.png`),
        require(`../../assets/report/LDotititem_2_13.png`),
        require(`../../assets/report/LDotititem_2_14.png`),
        require(`../../assets/report/LDotititem_2_15.png`),
        require(`../../assets/report/LDotititem_2_16.png`),
        require(`../../assets/report/LDotititem_2_17.png`),
        require(`../../assets/report/LDotititem_2_18.png`),
        require(`../../assets/report/LDotititem_2_19.png`),
        require(`../../assets/report/LDotititem_2_20.png`),
    ] : intl.options.currentLocale == 'de' ? [

        require(`../../assets/report/LDotdeitem_2_1.png`),
        require(`../../assets/report/LDotdeitem_2_2.png`),
        require(`../../assets/report/LDotdeitem_2_3.png`),
        require(`../../assets/report/LDotdeitem_2_4.png`),
        require(`../../assets/report/LDotdeitem_2_5.png`),
        require(`../../assets/report/LDotdeitem_2_6.png`),
        require(`../../assets/report/LDotdeitem_2_7.png`),
        require(`../../assets/report/LDotdeitem_2_8.png`),
        require(`../../assets/report/LDotdeitem_2_9.png`),
        require(`../../assets/report/LDotdeitem_2_10.png`),
        require(`../../assets/report/LDotdeitem_2_11.png`),
        require(`../../assets/report/LDotdeitem_2_12.png`),
        require(`../../assets/report/LDotdeitem_2_13.png`),
        require(`../../assets/report/LDotdeitem_2_14.png`),
        require(`../../assets/report/LDotdeitem_2_15.png`),
        require(`../../assets/report/LDotdeitem_2_16.png`),
        require(`../../assets/report/LDotdeitem_2_17.png`),
        require(`../../assets/report/LDotdeitem_2_18.png`),
        require(`../../assets/report/LDotdeitem_2_19.png`),
        require(`../../assets/report/LDotdeitem_2_20.png`),
    ] : intl.options.currentLocale == 'zh' ? [

        require(`../../assets/report/LDotzhitem_2_1.png`),
        require(`../../assets/report/LDotzhitem_2_2.png`),
        require(`../../assets/report/LDotzhitem_2_3.png`),
        require(`../../assets/report/LDotzhitem_2_4.png`),
        require(`../../assets/report/LDotzhitem_2_5.png`),
        require(`../../assets/report/LDotzhitem_2_6.png`),
        require(`../../assets/report/LDotzhitem_2_7.png`),
        require(`../../assets/report/LDotzhitem_2_8.png`),
        require(`../../assets/report/LDotzhitem_2_9.png`),
        require(`../../assets/report/LDotzhitem_2_10.png`),
        require(`../../assets/report/LDotzhitem_2_11.png`),
        require(`../../assets/report/LDotzhitem_2_12.png`),
        require(`../../assets/report/LDotzhitem_2_13.png`),
        require(`../../assets/report/LDotzhitem_2_14.png`),
        require(`../../assets/report/LDotzhitem_2_15.png`),
        require(`../../assets/report/LDotzhitem_2_16.png`),
        require(`../../assets/report/LDotzhitem_2_17.png`),
        require(`../../assets/report/LDotzhitem_2_18.png`),
        require(`../../assets/report/LDotzhitem_2_19.png`),
        require(`../../assets/report/LDotzhitem_2_20.png`),
    ] : [
        require(`../../assets/report/LDotitem_2_1.png`),
        require(`../../assets/report/LDotitem_2_2.png`),
        require(`../../assets/report/LDotitem_2_3.png`),
        require(`../../assets/report/LDotitem_2_4.png`),
        require(`../../assets/report/LDotitem_2_5.png`),
        require(`../../assets/report/LDotitem_2_6.png`),
        require(`../../assets/report/LDotitem_2_7.png`),
        require(`../../assets/report/LDotitem_2_8.png`),
        require(`../../assets/report/LDotitem_2_9.png`),
        require(`../../assets/report/LDotitem_2_10.png`),
        require(`../../assets/report/LDotitem_2_11.png`),
        require(`../../assets/report/LDotitem_2_12.png`),
        require(`../../assets/report/LDotitem_2_13.png`),
        require(`../../assets/report/LDotitem_2_14.png`),
        require(`../../assets/report/LDotitem_2_15.png`),
        require(`../../assets/report/LDotitem_2_16.png`),
        require(`../../assets/report/LDotitem_2_17.png`),
        require(`../../assets/report/LDotitem_2_18.png`),
        require(`../../assets/report/LDotitem_2_19.png`),
        require(`../../assets/report/LDotitem_2_20.png`),
    ]

    const Rimages = intl.options.currentLocale == 'it' ? [
        require(`../../assets/report/RDotititem_2_1.png`),
        require(`../../assets/report/RDotititem_2_2.png`),
        require(`../../assets/report/RDotititem_2_3.png`),
        require(`../../assets/report/RDotititem_2_4.png`),
        require(`../../assets/report/RDotititem_2_5.png`),
        require(`../../assets/report/RDotititem_2_6.png`),
        require(`../../assets/report/RDotititem_2_7.png`),
        require(`../../assets/report/RDotititem_2_8.png`),
        require(`../../assets/report/RDotititem_2_9.png`),
        require(`../../assets/report/RDotititem_2_10.png`),
        require(`../../assets/report/RDotititem_2_11.png`),
        require(`../../assets/report/RDotititem_2_12.png`),
        require(`../../assets/report/RDotititem_2_13.png`),
        require(`../../assets/report/RDotititem_2_14.png`),
        require(`../../assets/report/RDotititem_2_15.png`),
        require(`../../assets/report/RDotititem_2_16.png`),
        require(`../../assets/report/RDotititem_2_17.png`),
        require(`../../assets/report/RDotititem_2_18.png`),
        require(`../../assets/report/RDotititem_2_19.png`),
        require(`../../assets/report/RDotititem_2_20.png`),
    ] : intl.options.currentLocale == 'de' ? [

        require(`../../assets/report/RDotdeitem_2_1.png`),
        require(`../../assets/report/RDotdeitem_2_2.png`),
        require(`../../assets/report/RDotdeitem_2_3.png`),
        require(`../../assets/report/RDotdeitem_2_4.png`),
        require(`../../assets/report/RDotdeitem_2_5.png`),
        require(`../../assets/report/RDotdeitem_2_6.png`),
        require(`../../assets/report/RDotdeitem_2_7.png`),
        require(`../../assets/report/RDotdeitem_2_8.png`),
        require(`../../assets/report/RDotdeitem_2_9.png`),
        require(`../../assets/report/RDotdeitem_2_10.png`),
        require(`../../assets/report/RDotdeitem_2_11.png`),
        require(`../../assets/report/RDotdeitem_2_12.png`),
        require(`../../assets/report/RDotdeitem_2_13.png`),
        require(`../../assets/report/RDotdeitem_2_14.png`),
        require(`../../assets/report/RDotdeitem_2_15.png`),
        require(`../../assets/report/RDotdeitem_2_16.png`),
        require(`../../assets/report/RDotdeitem_2_17.png`),
        require(`../../assets/report/RDotdeitem_2_18.png`),
        require(`../../assets/report/RDotdeitem_2_19.png`),
        require(`../../assets/report/RDotdeitem_2_20.png`),
    ] : intl.options.currentLocale == 'zh' ? [

        require(`../../assets/report/RDotzhitem_2_1.png`),
        require(`../../assets/report/RDotzhitem_2_2.png`),
        require(`../../assets/report/RDotzhitem_2_3.png`),
        require(`../../assets/report/RDotzhitem_2_4.png`),
        require(`../../assets/report/RDotzhitem_2_5.png`),
        require(`../../assets/report/RDotzhitem_2_6.png`),
        require(`../../assets/report/RDotzhitem_2_7.png`),
        require(`../../assets/report/RDotzhitem_2_8.png`),
        require(`../../assets/report/RDotzhitem_2_9.png`),
        require(`../../assets/report/RDotzhitem_2_10.png`),
        require(`../../assets/report/RDotzhitem_2_11.png`),
        require(`../../assets/report/RDotzhitem_2_12.png`),
        require(`../../assets/report/RDotzhitem_2_13.png`),
        require(`../../assets/report/RDotzhitem_2_14.png`),
        require(`../../assets/report/RDotzhitem_2_15.png`),
        require(`../../assets/report/RDotzhitem_2_16.png`),
        require(`../../assets/report/RDotzhitem_2_17.png`),
        require(`../../assets/report/RDotzhitem_2_18.png`),
        require(`../../assets/report/RDotzhitem_2_19.png`),
        require(`../../assets/report/RDotzhitem_2_20.png`),
    ] : [
        require(`../../assets/report/RDotitem_2_1.png`),
        require(`../../assets/report/RDotitem_2_2.png`),
        require(`../../assets/report/RDotitem_2_3.png`),
        require(`../../assets/report/RDotitem_2_4.png`),
        require(`../../assets/report/RDotitem_2_5.png`),
        require(`../../assets/report/RDotitem_2_6.png`),
        require(`../../assets/report/RDotitem_2_7.png`),
        require(`../../assets/report/RDotitem_2_8.png`),
        require(`../../assets/report/RDotitem_2_9.png`),
        require(`../../assets/report/RDotitem_2_10.png`),
        require(`../../assets/report/RDotitem_2_11.png`),
        require(`../../assets/report/RDotitem_2_12.png`),
        require(`../../assets/report/RDotitem_2_13.png`),
        require(`../../assets/report/RDotitem_2_14.png`),
        require(`../../assets/report/RDotitem_2_15.png`),
        require(`../../assets/report/RDotitem_2_16.png`),
        require(`../../assets/report/RDotitem_2_17.png`),
        require(`../../assets/report/RDotitem_2_18.png`),
        require(`../../assets/report/RDotitem_2_19.png`),
        require(`../../assets/report/RDotitem_2_20.png`),
    ]


    return (
        <div>
            {Object.entries(_data).map((item, index) => (
                <div
                    style={Object.assign(item[1].position, { position: "absolute" })}
                    key={index}
                >
                    <div >
                        <div className="wheelCarDesc">
                            <label
                                className="wheelCarDesc__label"
                                style={{
                                    width: '100px',

                                }}
                            >
                                {returnTyrePosition(item[0])}：
                </label>

                        </div>

                        <div className={lang == 'zh' ? "wheelCarDesc" : 'wheelCarDesc1'} >
                            <span style={{ width: '120px', }} className="wheelCarDesc__cnt">
                                {returnDottx(item[1].info)}
                            </span>
                        </div>
                        <div className={lang == 'zh' ? "wheelCarDesc" : "wheelCarDesc1"}>

                            <span style={{ width: '120px', height: (lang == 'zh' || lang == 'it') ? '60px' : '120px' }} className="wheelCarDesc__cnt">
                                {model == 'dt.tyrescan.ts004' ? returnMSRemindTextAndImgIndex(item[1].info, item[1].wear,).text : returnRemindTextAndImgIndex(item[1].info, item[1].wear, item[1].season).text}
                            </span>
                        </div>

                    </div>
                    {model == 'dt.tyrescan.ts004' && (<div style={Object.assign(item[1].desc, { position: "absolute", marginTop: '0px' })}>
                        <img
                            style={{
                                width: 130,
                                height: 40
                            }}
                            resizemode="contain"
                            src={(index == 0 || index == 2) ? LMS[returnMSRemindTextAndImgIndex(item[1].info, item[1].wear).index] : RMS[returnMSRemindTextAndImgIndex(item[1].info, item[1].wear).index]} />
                    </div>)}

                    {model !== 'dt.tyrescan.ts004' && (<div style={Object.assign(item[1].desc, { position: "absolute", marginTop: '0px' })}>
                        <img
                            style={{
                                width: 130,
                                height: 40
                            }}
                            resizemode="contain"
                            src={(index == 0 || index == 2) ? Limages[returnRemindTextAndImgIndex(item[1].info, item[1].wear, item[1].season).index] : Rimages[returnRemindTextAndImgIndex(item[1].info, item[1].wear, item[1].season).index]} />
                    </div>)}
                </div>
            ))}
        </div>
    );
};

const RMS = [
    require(`../../assets/report/RMSDotitem_2_1.png`),
    require(`../../assets/report/RMSDotitem_2_2.png`),
    require(`../../assets/report/RMSDotitem_2_3.png`),
    require(`../../assets/report/RMSDotitem_2_4.png`),
    require(`../../assets/report/RMSDotitem_2_5.png`),
    require(`../../assets/report/RMSDotitem_2_6.png`),
    require(`../../assets/report/RMSDotitem_2_7.png`),
    require(`../../assets/report/RMSDotitem_2_8.png`),
    require(`../../assets/report/RMSDotitem_2_9.png`),
    require(`../../assets/report/RMSDotitem_2_10.png`),
    require(`../../assets/report/RMSDotitem_2_11.png`),
    require(`../../assets/report/RMSDotitem_2_12.png`),
    require(`../../assets/report/RMSDotitem_2_13.png`),
    require(`../../assets/report/RMSDotitem_2_14.png`),
    require(`../../assets/report/RMSDotitem_2_15.png`),
    require(`../../assets/report/RMSDotitem_2_16.png`),
    require(`../../assets/report/RMSDotitem_2_17.png`),
    require(`../../assets/report/RMSDotitem_2_18.png`),
    require(`../../assets/report/RMSDotitem_2_19.png`),
    require(`../../assets/report/RMSDotitem_2_20.png`),
]

const LMS = [
    require(`../../assets/report/LMSDotitem_2_1.png`),
    require(`../../assets/report/LMSDotitem_2_2.png`),
    require(`../../assets/report/LMSDotitem_2_3.png`),
    require(`../../assets/report/LMSDotitem_2_4.png`),
    require(`../../assets/report/LMSDotitem_2_5.png`),
    require(`../../assets/report/LMSDotitem_2_6.png`),
    require(`../../assets/report/LMSDotitem_2_7.png`),
    require(`../../assets/report/LMSDotitem_2_8.png`),
    require(`../../assets/report/LMSDotitem_2_9.png`),
    require(`../../assets/report/LMSDotitem_2_10.png`),
    require(`../../assets/report/LMSDotitem_2_11.png`),
    require(`../../assets/report/LMSDotitem_2_12.png`),
    require(`../../assets/report/LMSDotitem_2_13.png`),
    require(`../../assets/report/LMSDotitem_2_14.png`),
    require(`../../assets/report/LMSDotitem_2_15.png`),
    require(`../../assets/report/LMSDotitem_2_16.png`),
    require(`../../assets/report/LMSDotitem_2_17.png`),
    require(`../../assets/report/LMSDotitem_2_18.png`),
    require(`../../assets/report/LMSDotitem_2_19.png`),
    require(`../../assets/report/LMSDotitem_2_20.png`),
]

export default Tyre_dot


// WEBPACK FOOTER //
// ./src/views/report/ReportDot.js